import { AUTH_SCOPE } from 'src/services/consts/auth.const'

export const QUERY_KEYS = {
  PROCESSOR_GRAPH_PACKAGE: 'processor-graph-package',
  SUBPROCESSOR_LIST_MAP: 'subprocessor-list-map',
  SUBPROCESSOR_LIST_LINK: 'subprocessor-list-link',
  LINK_INVITE_LOGIN: 'link-invite-login',

  [AUTH_SCOPE.MAP]: 'email-access',
  [AUTH_SCOPE.LINK]: 'link-access',
}

export const MUTATION_KEYS = {
  LOGIN: 'login',
  // SHARE_GRANT is paired with useShareGrantMutation (grant reshare POST /share).
  SHARE_GRANT: 'shareGrant',
  // RETRY_SESSION is paired with useRetrySessionMutation (silent relogin + post-restore refetch).
  RETRY_SESSION: 'retry-session',
}

export const CACHE_TIMES = {
  xs: 1000 * 60 * 2,
  sm: 1000 * 60 * 5,
  md: 1000 * 60 * 10,
  lg: 1000 * 60 * 20,
  xl: 1000 * 60 * 30,
  endless: Infinity,
}

export const STALE_TIMES = {
  xs: 1000 * 10,
  sm: 1000 * 30,
  md: 1000 * 60 * 2,
  lg: 1000 * 60 * 5,
  xl: 1000 * 60 * 10,
  endless: Infinity,
}
